export const TOGGLE_ELEMENT = "toggle-entity";
export const TOGGLE_GROUP_ELEMENT = "toggle-group";
